function toNumber(value) {
  if (value === null || value === undefined || value === "") return null;

  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

function normalizeLocation(source) {
  if (!source || typeof source !== "object") return null;

  const lat = toNumber(source.lat ?? source.latitude);
  const lng = toNumber(source.lng ?? source.lon ?? source.long ?? source.longitude);

  if (lat === null || lng === null) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;

  return {
    lat,
    lng,
    label: source.label || source.name || source.title || source.address || null
  };
}

function findLocationCandidate(container) {
  if (!container || typeof container !== "object") return null;

  const nested = [container.location, container.coordinates, container.geo, container.map_location];
  for (let i = 0; i < nested.length; i++) {
    const normalized = normalizeLocation(nested[i]);
    if (normalized) return normalized;
  }

  return normalizeLocation(container);
}

function parseLocationFromContent(content) {
  if (typeof content !== "string") return null;

  // Case 1: JSON in markdown
  const markdownMatch = content.match(/```location\s*:\s*({[^`]*})[^`]*```/i);
  if (markdownMatch) {
    try {
      const locationData = JSON.parse(markdownMatch[1]);
      const normalized = normalizeLocation(locationData);
      if (normalized) return normalized;
    } catch (e) { /* ignore */ }
  }

  // Case 2: JSON-like object literal
  const plainObjectMatch = content.match(/location\s*:\s*({.*})/i);
  if (plainObjectMatch) {
    try {
      // The matched string is not valid JSON, so we need to convert it.
      const objectString = plainObjectMatch[1].replace(/(\w+)\s*:/g, '"$1":').replace(/'/g, '"');
      const locationData = JSON.parse(objectString);
      const normalized = normalizeLocation(locationData);
      if (normalized) return normalized;
    } catch (e) { /* ignore */ }
  }

  // Case 3: Loose key-value pairs. This is the most flexible.
  const latMatch = content.match(/(?:lat|latitude)\s*[:=]\s*['"]?(-?\d+(?:\.\d+)?)['"]?/i);
  const lngMatch = content.match(/(?:lng|lon|long|longitude)\s*[:=]\s*['"]?(-?\d+(?:\.\d+)?)['"]?/i);
  const labelMatch = content.match(/(?:label|name|title|address)\s*[:=]\s*['"]?([^,}\n\r'"]+)['"]?/i);

  if (latMatch && lngMatch) {
    return normalizeLocation({
      lat: latMatch[1],
      lng: lngMatch[1],
      label: labelMatch ? labelMatch[1].trim() : null
    });
  }

  return null;
}


// Extracts a location from a message, using a variety of strategies
export function extractMessageLocation(message) {
  const attrs = message && message.attributes;
  if (!attrs) return null;

  const metadata = attrs.metadata;
  const params = attrs.params;

  const candidates = [params, metadata, attrs, message];
  for (let i = 0; i < candidates.length; i++) {
    const location = findLocationCandidate(candidates[i]);
    if (location) return location;
  }

  const contentLocation = parseLocationFromContent(attrs.content);
  if (contentLocation) return contentLocation;

  return null;
}
